import React, { useState } from "react";
import { FiCheck, FiDownload, FiShield, FiFileText, FiBarChart2, FiZap, FiArrowRight } from "react-icons/fi";
import {
  Overlay,
  Card,
  ProgressBar,
  ProgressFill,
  CardBody,
  Title,
  Subtitle,
  FeatureGrid,
  FeatureCard,
  FeatureIcon,
  FeatureTitle,
  FeatureDesc,
  ButtonRow,
  PrimaryButton,
  SecondaryButton,
  SuccessIcon,
  TrialBadge,
  StepList,
  StepItem,
  StepNumber,
} from "./styles";

const FEATURES = [
  { icon: FiDownload, color: '#10b981', title: 'Download de XMLs', desc: 'Baixe XMLs automaticamente da SEFAZ via certificado digital' },
  { icon: FiFileText, color: '#3b82f6', title: 'Revisor de SPEDs', desc: 'Encontre inconsistências antes da fiscalização' },
  { icon: FiShield, color: '#f59e0b', title: 'Monitor eCAC', desc: 'Alertas de notificações e pendências fiscais' },
  { icon: FiBarChart2, color: '#8b5cf6', title: 'Créditos Tributários', desc: 'Identifique créditos que sua empresa pode recuperar' },
  { icon: FiZap, color: '#ef4444', title: 'Reforma Tributária', desc: 'Verifique conformidade com CBS, IBS e IS' },
  { icon: FiDownload, color: '#06b6d4', title: 'Gestão Multi-CNPJ', desc: 'Gerencie múltiplas empresas em um só lugar' },
];

const NEXT_STEPS = [
  { label: 'Envie seus arquivos SPED', desc: 'Faça upload de SPEDs para análise automatizada' },
  { label: 'Configure downloads de XML', desc: 'Ative o download automático pela SEFAZ' },
  { label: 'Explore o painel', desc: 'Veja movimentações, fornecedores e impostos' },
];

const TOTAL_STEPS = 3;

export default function OnboardingWizard({ onComplete }) {
  const [step, setStep] = useState(0);

  const progressPercent = ((step + 1) / TOTAL_STEPS) * 100;

  const renderStep = () => {
    switch (step) {
      case 0:
        return (
          <>
            <TrialBadge>
              <FiZap size={14} /> 14 dias grátis do plano Profissional
            </TrialBadge>
            <Title>Bem-vindo ao Vidal</Title>
            <Subtitle>
              Sua plataforma de automação fiscal está pronta. Seu projeto e certificado digital já foram configurados.
            </Subtitle>
            <FeatureGrid>
              {FEATURES.map((f, i) => (
                <FeatureCard key={i}>
                  <FeatureIcon $color={f.color}>
                    <f.icon size={18} />
                  </FeatureIcon>
                  <FeatureTitle>{f.title}</FeatureTitle>
                  <FeatureDesc>{f.desc}</FeatureDesc>
                </FeatureCard>
              ))}
            </FeatureGrid>
            <ButtonRow>
              <SecondaryButton onClick={onComplete}>Pular</SecondaryButton>
              <PrimaryButton onClick={() => setStep(1)}>
                Continuar <FiArrowRight size={16} style={{ marginLeft: 6, verticalAlign: 'middle' }} />
              </PrimaryButton>
            </ButtonRow>
          </>
        );

      case 1:
        return (
          <>
            <Title>Próximos passos</Title>
            <Subtitle>
              Recomendamos estas ações para aproveitar ao máximo o seu trial de 14 dias.
            </Subtitle>
            <StepList>
              {NEXT_STEPS.map((s, i) => (
                <StepItem key={i}>
                  <StepNumber>{i + 1}</StepNumber>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: '0.9rem', fontWeight: 600 }}>{s.label}</div>
                    <div style={{ fontSize: '0.78rem', opacity: 0.45, marginTop: 2 }}>{s.desc}</div>
                  </div>
                </StepItem>
              ))}
            </StepList>
            <ButtonRow>
              <SecondaryButton onClick={() => setStep(0)}>Voltar</SecondaryButton>
              <PrimaryButton onClick={() => setStep(2)}>
                Continuar <FiArrowRight size={16} style={{ marginLeft: 6, verticalAlign: 'middle' }} />
              </PrimaryButton>
            </ButtonRow>
          </>
        );

      case 2:
        return (
          <>
            <SuccessIcon>
              <FiCheck size={32} />
            </SuccessIcon>
            <Title style={{ textAlign: "center" }}>Tudo pronto!</Title>
            <Subtitle style={{ textAlign: "center" }}>
              Seu workspace está configurado e pronto para uso. Explore o painel e descubra o poder da automação fiscal.
            </Subtitle>
            <ButtonRow style={{ justifyContent: "center" }}>
              <PrimaryButton onClick={onComplete}>
                Explorar o Vidal <FiArrowRight size={16} style={{ marginLeft: 6, verticalAlign: 'middle' }} />
              </PrimaryButton>
            </ButtonRow>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <Overlay>
      <Card>
        <ProgressBar>
          <ProgressFill $percent={progressPercent} />
        </ProgressBar>
        <CardBody>
          {renderStep()}
        </CardBody>
      </Card>
    </Overlay>
  );
}
